// src/App.js
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/home/Home';
import Signin from './components/auth/Signin';
import Signup from './components/auth/Signup';
import Mainscreen from './components/dashboard/Mainscreen';
import Profile from './components/signIndropdown/Profile';
import TeamManagement from './components/signIndropdown/TeamManagement';
import HelpSupport from './components/signIndropdown/HelpSupport';
import SystemAccessPage from './components/auth/SystemAccessPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/signup" element={<Signup />} />

        {/* Main dashboard */}
        <Route path="/mainscreen/*" element={<Mainscreen />} />

        {/* Inspection bot routes */}
        <Route path="/inspectionbot/*" element={<Mainscreen />} />

        {/* Profile page */}
        <Route path="/profile" element={<Profile />} />

        {/* Profile page */}
        <Route path="/team-management" element={<TeamManagement />} />
        
        {/* Profile page */}
        <Route path="/help-support" element={<HelpSupport />} />

        {/* System Access page */}
        <Route path="/system-access" element={<SystemAccessPage />} />

        {/* Fallback to dashboard */}
        <Route path="*" element={<Navigate to="/mainscreen" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;